<template>
  <div class="fraud-control">
    <h5 v-translate>Report Date Range</h5>
    <b-row>
      <b-col>
        <label class="" for="inline-form-input-name" v-translate>Date Range</label><label v-show="reportRangeActive !== 0">&nbsp;[<a href="#" @click.prevent="resetReportRange" v-translate>reset range</a>]</label>
        <date-range-picker
          v-model="reportRange"
          @update="reportRangeActive++"
          :locale-data="locale"
          :opens="opens"
          class="mb-2 w-100"
          :ranges="ranges"
        >
          <div slot="input" slot-scope="picker">
            <font-awesome-icon :icon="['far', 'calendar-alt']" size="1x" style="vertical-align: middle" />
            <span v-if="reportRangeActive === 0" style="vertical-align: middle">...</span>
            <span v-else style="vertical-align: middle">{{moment(reportRange.startDate).format('L')}} - {{moment(reportRange.endDate).format('L')}}</span>
          </div>
        </date-range-picker>
      </b-col>
      <b-col>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col>
        <h5 v-translate>Fraud Report</h5>
        <label for="changed-field" v-translate>Changed Field</label>
        <b-form-select v-model="changedField" :options="changedFieldOptions" class="mb-3">
        </b-form-select>
        <b-button size="sm" variant="primary" :disabled="reportRangeActive === 0 || reportRequestInFlight" @click="generateFraudReport" v-translate>
          Generate
        </b-button>
      </b-col>
      <b-col>
        <h5 v-translate>Shipping Assignation Report</h5>
        <label for="changed-field" v-translate>Applied By</label>
        <b-form-select v-model="appliedBy" :options="appliedByOptions" class="mb-3">
        </b-form-select>
        <div v-if="appliedBy === 'user'">
          <user-autocomplete ref="userAc" @selected="onSearchUserSelected" with-picture class="mb-3" />
          <b-card v-if="user">
            <span class="bg-danger text-white d-block text-center" style="cursor: pointer; width: 1rem; height: 1rem; line-height: 1rem; position: absolute; top: 0; left: 0" href="#" @click.prevent="user = null">×</span>
            <user-card :user="user" />
          </b-card>
        </div>
        <b-button size="sm" variant="primary" :disabled="reportRangeActive === 0 || reportRequestInFlight" @click="generateAssignationReport" v-translate>
          Generate
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import UserAutocomplete from '@/components/autocompletes/UserAutocomplete'
import UserCard from '@/components/UserCard'

export default {
  name: 'FraudControl',
  components: {
    UserAutocomplete,
    UserCard,
    DateRangePicker
  },
  data() {
    return {
      reportRange: {
        startDate: this.moment().toDate(),
        endDate: this.moment().toDate()
      },
      reportRangeActive: 0,
      opens: 'right',
      locale: {
        direction: 'ltr', //  direction of text
        format: 'dd/mm/yyyy', //  fomart of the dates displayed
        separator: ' - ', //  separator between the two ranges
        applyLabel: this.$gettext('Apply'),
        cancelLabel: this.$gettext('Cancel'),
        weekLabel: 'W',
        customRangeLabel: this.$gettext('Custom Range'),
        daysOfWeek: this.moment.weekdaysMin(), // days, //  array of days - see moment documenations for details
        monthNames: this.moment.monthsShort(), //  array of month names - see moment documenations for details
        firstDay: 1,
        showWeekNumbers: false //  show week numbers on each row of the calendar
      },
      ranges: {
        [this.$gettext('Today')]: [this.moment().toDate(), this.moment().toDate()],
        [this.$gettext('Yesterday')]: [this.moment().subtract(1, 'days').toDate(), this.moment().subtract(1, 'days').toDate()],
        [this.$gettext('Last 7 days')]: [this.moment().subtract(6, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('Last 30 days')]: [this.moment().subtract(29, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('This month')]: [this.moment().startOf('month').toDate(), this.moment().endOf('month').toDate()],
        [this.$gettext('This year')]: [this.moment().startOf('year').toDate(), this.moment().endOf('year').toDate()],
        [this.$gettext('Last week')]: [this.moment().subtract(1, 'week').startOf('week').toDate(), this.moment().subtract(1, 'week').endOf('week').toDate()],
        [this.$gettext('Last month')]: [this.moment().subtract(1, 'month').startOf('month').toDate(), this.moment().subtract(1, 'month').endOf('month').toDate()]
      },
      datepickerLocalized: false,
      changedField: 'courier_commission',
      changedFieldOptions: [
        {
          text: this.$gettext('Courier Commission'),
          value: 'courier_commission'
        },
        {
          text: this.$gettext('Price'),
          value: 'price'
        }
      ],
      appliedBy: 'everyone',
      appliedByOptions: [
        {
          text: this.$gettext('Everyone'),
          value: 'everyone'
        },
        {
          text: this.$gettext('Ops + Ops Sup'),
          value: 'ops'
        },
        {
          text: this.$gettext('A particular user'),
          value: 'user'
        }
      ],
      user: null,
      acOptions: {
        debounce: 500,
        placeholder: this.$gettext('User Name or Email'),
        inputClass: 'form-control'
      },
      minCharacter: 2,
      searchUserQuery: ''
    }
  },
  methods: {
    resetReportRange() {
      this.reportRange = {
        startDate: this.moment().toDate(),
        endDate: this.moment().toDate()
      }
      this.reportRangeActive = 0
    },
    generateFraudReport() {
      const params = {
        format: 'upload',
        date_from: this.moment(this.reportRange.startDate).format('YYYY-MM-DD'),
        date_to: this.moment(this.reportRange.endDate).format('YYYY-MM-DD'),
        changed_field: this.changedField
      }
      return this.generateReportAsync({url: this.$appConfig.api.baseUrl + 'shippings/history/fraud-report', params})
    },
    generateAssignationReport() {
      const params = {
        format: 'upload',
        filter_groups: [
          {
            filters: [
              ['status', 'eq', 'CONFIRMED'],
              ['created_at', 'bt', [this.moment(this.reportRange.startDate).format('YYYY-MM-DD HH:mm:ss'), this.moment(this.reportRange.endDate).format('YYYY-MM-DD HH:mm:ss')]]
            ]
          }
        ]
      }
      if (this.appliedBy === 'ops') {
        const usersParams = {
          filter_groups: [
            {
              filters: [
                ['roles.name', 'in', ['operator', 'operator-supervisor']]
              ]
            }
          ]
        }
        // the ops branch needs the operator ids before it can ask for the report; passing the whole
        // chain as `params` keeps the in-flight guard covering both requests, not just the last one
        return this.generateReportAsync({
          url: this.$appConfig.api.baseUrl + 'shippings/statuses',
          params: () => this.$http.get(this.$appConfig.api.baseUrl + 'users', {params: usersParams})
            .then(response => {
              params.filter_groups[0].filters.push(['applied_by_id', 'in', response.body.data.map(x => { return x.id })])
              return params
            })
        })
      } else {
        if (this.appliedBy === 'user' && this.user && this.user.id) {
          params.filter_groups[0].filters.push(['applied_by_id', 'eq', this.user.id])
        }
        return this.generateReportAsync({url: this.$appConfig.api.baseUrl + 'shippings/statuses', params})
      }
    },
    onSearchUserSelected(item) {
      this.user = item
      this.$refs.userAc.searchQuery = ''
    }
  }
}
</script>
